import { SurveyQuestionBoolean } from 'survey-react-ui';
import { IonCheckbox, IonItem, IonLabel } from '@ionic/react';
import classNames from 'classnames';

import groupStyles from '../../Form/_styles/group.module.scss';
import styles from './SurveyBoolean.module.scss';

export class SurveyBoolean extends SurveyQuestionBoolean {
  protected renderElement(): JSX.Element {
    return (
      <div className={classNames(styles.root)}>
        <IonItem lines="none">
          <IonCheckbox
            slot="start"
            labelPlacement="end"
            className={groupStyles.control}
            name={this.question.name}
            id={this.question.inputId}
            disabled={this.question.isDisabledAttr}
            checked={this.question.booleanValue || false}
            onIonChange={this.handleOnChange}
            value={
              this.question.booleanValue === null
                ? ''
                : this.question.booleanValue
            }
          />
          <IonLabel>{this.question.title}</IonLabel>
        </IonItem>
      </div>
    );
  }
}
